module.exports = __webpack_public_path__ + "img/solartool.1817a538.jpg";